<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="app-container">
    <!-- Header Section -->
    <Header
      :isDropdownOpen="isDropdownOpen"
      @toggleDropdown="toggleDropdown"
      @handleLoginSelection="handleLoginSelection"
      @handleSignUpSelection="handleSignUpSelection"
    />

    <!-- Main Content -->
    <main class="container">
      <div class="left-container">
        <div v-if="listing" class="listing-details">
          <div v-if="listing" class="listing-info">
            <h2>{{ listing.title }}</h2>
            <h6 class="subheading">{{ listing.location }}</h6>
            <div
              v-if="!listing?.isActive && !listing?.isCompleted"
              style="margin-top: 0.5rem"
            >
              <Chip
                :class="[
                  'selected-chip',
                  'small-chip',
                  // { 'selected-chip': selectedSlot === slot },
                  // { 'disabled-chip': !slot.isAvailable },
                ]"
                >Coming Soon</Chip
              >
            </div>
            <div v-else-if="listing?.isCompleted" style="margin-top: 0.5rem">
              <Chip
                :class="[
                  'selected-chip',
                  'small-chip',
                  // { 'selected-chip': selectedSlot === slot },
                  // { 'disabled-chip': !slot.isAvailable },
                ]"
                >Sold out</Chip
              >
            </div>
            <img :src="listing.bannerUrl" class="listing-cover" />

            <div class="event-header">
              <div class="event-header-info">
                <h3 class="h3-style">Private drone tour hosted by Skyhost</h3>
                <h6 class="subheading">30 min · Online Event</h6>
              </div>
              <!-- <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8jXULUjL7PbaFClpallWqF4YxmYjmYQZdCQ&s"
                alt="User"
                class="user-image"
              /> -->
            </div>

            <hr class="line-divider" />

            <div class="listing-features">
              <div class="feature-item">
                <vue-feather type="monitor" size="18"></vue-feather>
                <div class="feature-item-content">
                  <strong>Private viewing</strong>
                  <p>You'll have the event to yourself and your guest</p>
                </div>
              </div>
              <div class="feature-item">
                <vue-feather type="mic" size="18"></vue-feather>
                <div class="feature-item-content">
                  <strong>Group Conversation</strong>
                  <p>Engage with the pilot and the guests</p>
                </div>
              </div>
              <div class="feature-item">
                <vue-feather type="radio" size="18"></vue-feather>
                <div class="feature-item-content">
                  <strong>Real time</strong>
                  <p>Low latency live streaming</p>
                </div>
              </div>
            </div>

            <h5 class="listing-description">{{ listing.description }}</h5>

            <hr class="line-divider" />

            <div class="map-container">
              <h3 class="h3-style">Where we'll be flying</h3>
              <div class="map-image">
                <MapComponent
                  :latitude="listing.latitude"
                  :longitude="listing.longitude"
                />
              </div>
              <div class="location-coordinates">
                <strong class="location">{{ listing.location }}</strong>
                <div class="coordinates">
                  <p class="latitude">{{ listing.latitude }} N</p>
                  <p class="longitude">{{ listing.longitude }} E</p>
                </div>
              </div>
            </div>

            <hr class="line-divider" />

            <div class="things-container">
              <h3 class="h3-style">Things to know</h3>
              <div class="things-list">
                <div class="thing-item">
                  <vue-feather type="check-circle" size="18" />
                  <span>Check-in: 15 minutes for departure</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="wifi" size="18" />
                  <span>Ensure a stable internet connection</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="user-check" size="18" />
                  <span
                    >Do not ask for personal contacts from pilots or other
                    participants</span
                  >
                </div>
                <div class="thing-item">
                  <vue-feather type="mic" size="18" />
                  <span
                    >Please mute your microphone when you are not speaking</span
                  >
                </div>
                <div class="thing-item">
                  <vue-feather type="x-circle" size="18" />
                  <span>No unauthorized recording</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="user-x" size="18" />
                  <span>No harassment</span>
                </div>
              </div>
            </div>

            <!-- add a section to display please use desktop app to book -->
            <!-- <div class="desktop-app-section">
              <div class="desktop-app-image">
                <vue-feather type="monitor" size="32"></vue-feather>
              </div>
              <h4>To continue booking, access www.skyhost.ai from desktop</h4>
            </div> -->
            <!-- <hr class="line-divider" /> -->

            <!-- Key Points Widget -->
            <!-- <br /> -->
            <!-- <h3 class="h3-style">Why book a Skyhost flight?</h3>
            <div class="key-points-container">
              <div class="key-point-widget">
                <span class="key-point-icon">🌍</span>
                <span class="key-point-text"> Travel the world together! </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🎂</span>
                <span class="key-point-text"> Celebrate birthday parties </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">👨‍👩‍👧‍👦</span>
                <span class="key-point-text">
                  Get togethers with friends and family
                </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🧑‍✈️</span>
                <span class="key-point-text"> Max 8 tickets per flight </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🚁</span>
                <span class="key-point-text">
                  Live, aerial, educational flight with your child
                </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🏫</span>
                <span class="key-point-text">
                  Invite classmates to join from their homes, or watch together
                  on a big screen
                </span>
              </div>
            </div> -->

            <hr class="line-divider" />

            <div v-if="listing?.isActive" class="disclaimer">
              <vue-feather
                type="alert-triangle"
                size="18"
                class="warning-icon"
              ></vue-feather>
              <span>
                Note: Your flight is only confirmed when at least 6 tickets are
                booked for a given slot.
              </span>
            </div>

            <!-- Modern Mobile Booking Container -->
            <div class="booking-container-mobile" v-if="listing?.isActive">
              <div class="booking-header-mobile">
                <div class="timezone-selector-mobile">
                  <select v-model="userTimezone" class="timezone-select-mobile">
                    <option v-for="tz in timezones" :key="tz" :value="tz">
                      {{ formatTimezone(tz) }}
                    </option>
                  </select>
                  <p class="timezone-info-mobile">
                    <vue-feather type="clock" size="14"></vue-feather>
                    View times in your preferred timezone
                  </p>
                </div>
              </div>

              <div class="select-time-header-mobile" style="padding: 0 1.5rem">
                <h4>Select date</h4>
              </div>

              <!-- Mobile Calendar -->
              <VCalendar
                :key="calendarKey"
                :attributes="attrs"
                :disabled-dates="disabledDates"
                title-position="left"
                borderless
                expanded
                transparent
                @dayclick="handleDayClickNew"
                :min-date="displayStartDate"
                :max-date="displayEndDate"
                class="mobile-calendar"
              />

              <div class="booking-info-mobile">
                <div class="select-time-header-mobile">
                  <h4>Select Time</h4>
                </div>

                <!-- Add this new section for when no slots are available -->
                <div v-if="!slots.length" class="empty-slots-container-mobile">
                  <vue-feather
                    type="calendar"
                    size="18"
                    class="empty-slots-icon"
                  />
                  <p class="empty-slots-message">
                    Select an available date to view time slots
                  </p>
                </div>

                <!-- Existing slots container -->
                <div v-else class="slots-container-mobile">
                  <Chip
                    v-for="slot in slots"
                    :key="slot.timeSlot"
                    :class="[
                      'small-chip-mobile',
                      selectedSlot === slot
                        ? 'selected-chip-mobile'
                        : !slot.isAvailable
                        ? 'disabled-chip-mobile'
                        : getOccupancyPercentage(slot) >= 70
                        ? 'danger-chip-mobile'
                        : getOccupancyPercentage(slot) >= 50
                        ? 'warning-chip-mobile'
                        : 'available-chip-mobile',
                    ]"
                    @click="slot.isAvailable ? selectSlot(slot) : null"
                    :style="{
                      textDecoration: !slot.isAvailable
                        ? 'line-through'
                        : 'none',
                    }"
                  >
                    <div class="chip-content-mobile">
                      <span class="chip-time-mobile">{{
                        slot.timeString
                      }}</span>
                      <span class="chip-availability-mobile">
                        {{ slot.currentGuestCount || 0 }}/{{
                          slot.maxGuestCount || 3
                        }}
                      </span>
                    </div>
                  </Chip>
                </div>
              </div>

              <!-- Guest Counter Section Mobile -->
              <div class="guest-counter-section-mobile">
                <div class="guest-counter-container-mobile">
                  <div class="guest-counter-label-mobile">
                    <h4>TICKETS</h4>
                    <p>
                      {{ guestCount }} ticket{{ guestCount > 1 ? "s" : "" }}
                    </p>
                  </div>
                  <div class="guest-counter-controls-mobile">
                    <button
                      @click="decrementGuests"
                      :disabled="guestCount <= 1"
                      class="guest-counter-btn-mobile"
                    >
                      −
                    </button>
                    <button
                      @click="incrementGuests"
                      :disabled="guestCount >= maxSelectableGuests"
                      class="guest-counter-btn-mobile"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>

              <div class="booking-summary-mobile">
                <div class="summary-row-mobile">
                  <div class="summary-label-mobile">
                    <p>
                      {{ guestCount }} ticket{{ guestCount > 1 ? "s" : "" }}
                    </p>
                  </div>
                  <p class="summary-value-mobile">
                    {{ totalCreditsNeeded }} credit{{
                      totalCreditsNeeded > 1 ? "s" : ""
                    }}
                  </p>
                </div>

                <div class="credit-balance-mobile">
                  <p>Your Credit Balance</p>
                  <p>{{ creditBalance }} credits</p>
                </div>

                <button
                  class="book-button-mobile"
                  @click="bookPrivateEvent()"
                  :disabled="!selectedDate || !selectedSlot"
                >
                  Book Now
                </button>

                <p class="terms-note-mobile">Terms and conditions apply</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-container"></div>
    </main>

    <!-- <Footer /> -->

    <SignUpModal
      :isOpen="isSignUpModalOpen"
      @close="closeSignUpModal"
      :onSubmit="handleSignUp"
      @openLoginModal="openLoginModal"
      :errorMessage="errorMessage"
    />

    <LoginModal
      :isOpen="isLoginModalOpen"
      @close="closeLoginModal"
      @openSignUpModal="openSignUpModal"
      :onSubmit="handleLoginButton"
      :errorMessage="errorMessage"
    />

    <ReservationConfirmModal
      v-if="showConfirmModal"
      :tourName="listing.title"
      :tourImage="listing.bannerUrl"
      :location="listing.location"
      :duration="30 + ' min'"
      :selectedDate="selectedDate"
      :selectedSlot="selectedSlot.timeString"
      :creditBalance="creditBalance"
      :guestCount="guestCount"
      :isAgent="isUserAgent"
      @close="showConfirmModal = false"
      @confirm="handleConfirmBooking"
    />
  </div>
</template>

<script>
import {
  getFirestore,
  doc,
  getDoc,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import { isMobile } from "@/utils/helper";
import { computed } from "vue";
import { ref } from "vue";
import Chip from "primevue/chip";
import { auth, db } from "@/plugins/firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { useSessionStore } from "../stores/session";
import SignUpModal from "@/components/organisms/modal/signUpModal.vue";
import LoginModal from "../components/organisms/modal/loginModal.vue";
import { loginService, userAuth } from "../services/userAuth";
import { amplitude } from "../plugins/amplitude";
import Header from "@/components/organisms/Header.vue";
import MapComponent from "@/components/samplemap.vue";
import { truncateText } from "@/utils/helper";
import { useRoute } from "vue-router";
import { creditService } from "@/services/creditService";
import ReservationConfirmModal from "@/components/organisms/ReservationConfirmModal.vue";
// import Footer from "@/components/Footer.vue";

export default {
  components: {
    Chip,
    SignUpModal,
    Header,
    MapComponent,
    LoginModal,
    ReservationConfirmModal,
  },
  data() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return {
      listing: null,
      selectedDate: null,
      slots: [],
      selectedSlot: null,
      slotsByDate: new Map(),
      promoDiscount: 50,
      errorMessage: "",
      isSignUpModalOpen: false,
      isLoginModalOpen: false,
      selectedOption: null,
      listingId: null,
      userTimezone: userTimezone,
      timezones: Intl.supportedValuesOf("timeZone"),
      showConfirmModal: false,
      creditBalance: 0,
      displayStartDate: new Date(),
      displayEndDate: new Date(),
      guestCount: 1,
      guestInfo: [],
    };
  },
  computed: {
    isUserAuthenticated() {
      const sessionStore = useSessionStore();
      return sessionStore.userId !== null;
    },
    isUserAgent() {
      const sessionStore = useSessionStore();
      return sessionStore.user?.isAgent;
    },
    calendarKey() {
      return this.userTimezone;
    },
    disabledDates() {
      if (
        !this.listing?.eventSchedule ||
        this.listing.eventSchedule.length === 0
      ) {
        return [];
      }

      // Get all available dates from the converted timezone schedule
      const availableDates = this.convertedTimezoneSchedule.map((event) => {
        // Parse the userDate string (e.g., "March 11, 2025") to create a proper date
        const dateParts = event.userDate.split(/[\s,]+/);
        const month = dateParts[0];
        const day = parseInt(dateParts[1]);
        const year = parseInt(dateParts[2]);

        // Create date object for comparison
        const monthIndex = new Date(`${month} 1, 2000`).getMonth();
        return new Date(year, monthIndex, day);
      });

      // Generate all dates between displayStartDate and displayEndDate
      const allDates = [];
      const currentDate = new Date(this.displayStartDate);
      const endDate = new Date(this.displayEndDate);

      while (currentDate <= endDate) {
        allDates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      // Filter out dates that have available slots
      const disabledDates = allDates.filter((date) => {
        return !availableDates.some(
          (availableDate) =>
            availableDate.getFullYear() === date.getFullYear() &&
            availableDate.getMonth() === date.getMonth() &&
            availableDate.getDate() === date.getDate()
        );
      });

      return disabledDates;
    },
    convertedTimezoneSchedule() {
      if (!this.listing || !this.listing.eventSchedule) {
        return [];
      }

      return this.listing.eventSchedule.map((event) => {
        const utcDate = new Date(event.datetime);

        // Format date and time in listing timezone
        const listingDate = utcDate.toLocaleDateString("en-US", {
          timeZone: this.listing.timezone,
          month: "long",
          day: "numeric",
          year: "numeric",
        });

        const listingTime = utcDate.toLocaleTimeString("en-US", {
          timeZone: this.listing.timezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        // Format date and time in user timezone
        const userDate = utcDate.toLocaleDateString("en-US", {
          timeZone: this.userTimezone,
          month: "long",
          day: "numeric",
          year: "numeric",
        });

        const userTime = utcDate.toLocaleTimeString("en-US", {
          timeZone: this.userTimezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return {
          slotId: event.slotId,
          datetime: event.datetime,
          listingDate,
          listingTime,
          userDate,
          userTime,
          isAvailable: event.isAvailable,
          isLocked: event.isLocked,
          maxGuestCount: event.maxGuestCount || 3,
          currentGuestCount: event.currentGuestCount || 0,
        };
      });
    },
    maxSelectableGuests() {
      if (!this.selectedSlot) return 1;
      const available =
        (this.selectedSlot.maxGuestCount || 3) -
        (this.selectedSlot.currentGuestCount || 0);
      return Math.max(1, available);
    },
    totalCreditsNeeded() {
      return this.guestCount;
    },
  },
  methods: {
    handleLoginSelection() {
      this.openLoginModal();
    },
    handleSignUpSelection() {
      this.openSignUpModal();
    },
    async handleLoginButton(data) {
      // Track login attempt
      amplitude.track("Login Form Submitted", {
        type: "login",
        source: "listing_mobile_page",
        email_domain: data.email.split("@")[1] || "unknown",
        timestamp: new Date().toISOString(),
      });

      this.errorMessage = "";

      try {
        const user = await loginService.loginUser(data.email, data.password);
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        // Track successful login
        amplitude.track("Login Success", {
          userId: user.uid,
          email: user.email,
          source: "listing_mobile_page",
          timestamp: new Date().toISOString(),
        });

        this.closeLoginModal();

        // Set up credit balance listener with the new user ID
        this.setupCreditBalanceListener();
      } catch (error) {
        this.errorMessage = error.message;

        // Track login failure with specific error type
        let errorType = "unknown";
        if (error.message.includes("password")) {
          errorType = "wrong_password";
        } else if (error.message.includes("No account")) {
          errorType = "user_not_found";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("Too many failed")) {
          errorType = "too_many_attempts";
        }

        amplitude.track("Login Failed", {
          error_type: errorType,
          error_message: error.message,
          source: "listing_mobile_page",
          timestamp: new Date().toISOString(),
        });
      }
    },
    setDisabledDates() {
      const disabled = [];
      const startDate = new Date(this.listing.startDate);
      const endDate = new Date(this.listing.endDate);

      for (
        let date = startDate;
        date <= endDate;
        date.setDate(date.getDate() + 1)
      ) {
        const dateKey = date.toISOString().split("T")[0];
        if (this.listing.slotsByDate[dateKey]?.length === undefined) {
          disabled.push(new Date(dateKey));
        }
      }
      this.disabledDates = disabled;
    },
    openLoginModal() {
      this.isLoginModalOpen = true;
    },
    closeLoginModal() {
      this.isLoginModalOpen = false;
      this.errorMessage = "";
    },
    openSignUpModal() {
      this.isSignUpModalOpen = true;

      // Track when signup modal is opened
      amplitude.track("SignUp Modal Opened", {
        source: "listing_mobile_page",
        listingId: this.listingId,
        listingTitle: this.listing?.title || "unknown",
        timestamp: new Date().toISOString(),
      });
    },
    closeSignUpModal() {
      this.isSignUpModalOpen = false;
      this.errorMessage = "";
    },
    getTruncatedDescription(description, maxLength) {
      return truncateText(description, maxLength); // Adjust the character limit as needed
    },
    fetchListing() {
      const db = getFirestore();
      const listingRef = doc(db, "listings", this.listingId);
      getDoc(listingRef).then((doc) => {
        if (doc.exists()) {
          this.listing = doc.data();
        } else {
          console.log("No such document!");
        }
      });
    },
    convertToUserTimeZone(utcDate, timeZone) {
      // Convert the UTC date to the user's timezone in 12-hour format
      const date = new Date(utcDate); // Convert to Date object
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return formatter.format(date); // Returns time in "hh:mm AM/PM" format
    },
    convertData(data, timeZone) {
      // Function to convert the time and date to user's timezone
      const convertedDate = this.convertToUserTimeZone(
        data.timeSlot.date,
        timeZone
      );
      return {
        ...data,
        timeSlot: {
          ...data.timeSlot,
          timeString: convertedDate, // Update timeString in user timezone
          date: new Date(data.timeSlot.date).toLocaleString("en-US", {
            timeZone,
          }), // Update date to user timezone
        },
      };
    },
    handleDayClickNew(date) {
      console.log("handleDayClickNew called with date:", date.id);
      this.selectedSlot = null;
      // Reset slots at the beginning to clear any previous selection
      this.slots = [];

      // Format the selected date to YYYY-MM-DD for comparison
      const selectedDateStr = new Date(date.id).toISOString().split("T")[0];
      console.log("Selected date (YYYY-MM-DD):", selectedDateStr);

      // Check if this date exists in our convertedTimezoneSchedule
      const eventsOnSelectedDate = this.convertedTimezoneSchedule.filter(
        (event) => {
          // Instead of converting to Date object which causes timezone issues,
          // directly compare with the calendar date by formatting both to the same format

          // Get the month, day, and year from userDate string (e.g., "March 11, 2025")
          const dateParts = event.userDate.split(/[\s,]+/); // Split by spaces and commas
          const month = dateParts[0]; // "March"
          const day = parseInt(dateParts[1]); // 11
          const year = parseInt(dateParts[2]); // 2025

          // Get the calendar date components
          const calDate = new Date(date.id);
          const calMonth = calDate.toLocaleString("en-US", { month: "long" }); // "March"
          const calDay = calDate.getDate(); // 10
          const calYear = calDate.getFullYear(); // 2025

          // Simple comparison of components
          const isMatch =
            month === calMonth && day === calDay && year === calYear;

          return isMatch;
        }
      );

      console.log(
        `Found ${eventsOnSelectedDate.length} events on selected date in user timezone`
      );

      // Always update the selected date to highlight it in the calendar
      this.selectedDate = date.id;

      if (eventsOnSelectedDate.length === 0) {
        console.log("No available events on this date in your timezone");
        return;
      }

      // Map the events to slots format
      this.slots = eventsOnSelectedDate.map((event) => {
        return {
          timeSlot: {
            date: event.datetime,
            timeString: event.userTime,
          },
          isAvailable: event.isAvailable,
          isLocked: event.isLocked || false,
          slotId: event.slotId,
          timeString: event.userTime, // Add directly to the object for easier access
          maxGuestCount: event.maxGuestCount || 3,
          currentGuestCount: event.currentGuestCount || 0,
        };
      });

      // Update calendar attributes to show selected date
      this.updateCalenderAttributes();
    },
    handleDayClick(date) {
      console.log("handleDayClick", date);
      this.selectedSlot = null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startDate = new Date(this.listing.startDate);
      const endDate = new Date(this.listing.endDate);
      const selectedDate = new Date(date.id);
      const formattedSelectedDate = selectedDate.toISOString().split("T")[0];
      const formatedDisabledDates = this.disabledDates.map(
        (date) => date.toISOString().split("T")[0]
      );
      const isDisabled = formatedDisabledDates.includes(formattedSelectedDate);
      console.log("this.disabledDates", isDisabled);
      if (
        selectedDate < startDate ||
        selectedDate > endDate ||
        selectedDate < today ||
        isDisabled
      ) {
        console.log("Selected date is out of range.");
        return;
      }

      this.selectedDate = date.id;

      const dateKey = selectedDate.toISOString().split("T")[0];
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const listingTimezone = this.listing.timezone;

      this.userTimezone = userTimezone;

      console.log("User Timezone:", userTimezone);
      console.log("Listing Timezone:", listingTimezone);

      const slots = (this.slots = this.listing.slotsByDate[dateKey] || []);
      this.slots = slots.map((slot) =>
        this.convertToTargetTimezone(slot, userTimezone)
      );
      this.updateCalenderAttributes();
    },
    async handleSignUp(data) {
      console.log("Sign up form submitted!");
      this.errorMessage = "";

      // Track signup attempt with more detailed information
      amplitude.track("SignUp Form Submitted", {
        type: "signUp",
        source: "listing_mobile_page",
        listingId: this.listingId,
        listingTitle: this.listing?.title || "unknown",
        timestamp: new Date().toISOString(),
      });

      try {
        const user = await userAuth.signUpUser(
          data.username,
          data.email,
          data.password,
          data.confirmPassword
        );
        console.log("Signed in as:", user.email);
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        // Track successful signup
        amplitude.track("SignUp Success", {
          userId: user.uid,
          email: user.email,
          displayName: user.displayName || data.username,
          source: "listing_mobile_page",
          listingId: this.listingId,
          timestamp: new Date().toISOString(),
        });

        this.closeSignUpModal();

        // Set up credit balance listener with the new user ID
        this.setupCreditBalanceListener();
      } catch (error) {
        console.log(error);
        this.errorMessage = error.message;

        // Track signup failure with specific error type
        let errorType = "unknown_error";
        if (error.message.includes("already in use")) {
          errorType = "email_already_in_use";
        } else if (error.message.includes("Invalid email")) {
          errorType = "invalid_email";
        } else if (error.message.includes("weak")) {
          errorType = "weak_password";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("match")) {
          errorType = "passwords_dont_match";
        } else if (error.message.includes("fill in all")) {
          errorType = "missing_fields";
        } else if (error.message.includes("disabled")) {
          errorType = "account_disabled";
        }

        // Track signup failure with error information
        amplitude.track("SignUp Failed", {
          errorCode: error.code || "unknown_error",
          errorType: errorType,
          errorMessage: error.message,
          source: "listing_mobile_page",
          listingId: this.listingId,
          timestamp: new Date().toISOString(),
        });
      }
    },
    selectSlot(slot) {
      this.selectedSlot = slot;
      // Reset guest count when selecting a new slot
      this.guestCount = 1;
    },
    incrementGuests() {
      if (this.guestCount < this.maxSelectableGuests) {
        this.guestCount++;
      }
    },
    decrementGuests() {
      if (this.guestCount > 1) {
        this.guestCount--;
      }
    },
    /**
     * https://stackoverflow.com/questions/66382652/how-to-style-vue-v-calendar-io-date-circle-color-and-text-color
     */
    updateCalenderAttributes() {
      // const today = new Date();
      // today.setHours(0, 0, 0, 0);
      // const dateKeys = Object.keys(this.listing.slotsByDate).filter(
      //   (dateKey) => new Date(dateKey) >= today
      // );

      this.attrs = [
        {
          key: "today",
          dot: {
            color: "#42b983",
          },
          dates: new Date(),
        },
        // {
        //   key: "alldates",
        //   highlight: {
        //     contentStyle: {
        //       fontSize: "8px",
        //     },
        //   },
        //   dates: allDates,
        // },
        // {
        //   key: "eligible",
        //   dot: {
        //     color: "#000",
        //     fillMode: "light",
        //   },
        //   dates: dateKeys,
        // },
        {
          key: "selected",
          highlight: {
            style: {
              backgroundColor: "#000",
            },
            fillMode: "solid",
          },
          dates: this.selectedDate ? [this.selectedDate] : [],
        },
      ];
    },
    async bookPrivateEvent() {
      if (!this.isUserAuthenticated) {
        this.openSignUpModal();
        return;
      }

      this.showConfirmModal = true;
    },
    async handleConfirmBooking(confirmData = {}) {
      const { guestInfo = [] } = confirmData;
      this.guestInfo = guestInfo;
      try {
        const sessionStore = useSessionStore();
        const userId = sessionStore.userId;

        const convertedEvent = this.convertedTimezoneSchedule.find(
          (event) => event.slotId === this.selectedSlot.slotId
        );

        // For backward compatibility, maintain the original structure too
        const reservationData = {
          listingId: this.listingId,
          listingUserId: this.listing.creatorUserId,
          createdBy: auth.currentUser.uid,
          selectedDate: this.selectedDate,
          slotId: this.selectedSlot.slotId,
          userTimezone: this.userTimezone,
          listingTimezone: this.listing.timezone,
          listingDate: convertedEvent?.listingDate || "",
          listingTime: convertedEvent?.listingTime || "",
          eventSchedule: {
            listing: {
              timezone: this.listing.timezone,
              date: convertedEvent?.listingDate || "",
              time: convertedEvent?.listingTime || "",
            },
            user: {
              timezone: this.userTimezone,
              date: convertedEvent?.userDate || "",
              time: convertedEvent?.userTime || "",
            },
          },
          creditUsed: this.guestCount,
          guestCount: this.guestCount,
          guestInfo: this.guestInfo,
          isCancelled: false,
          isConfirmed: true,
          roomCode: null,
          createdAt: new Date(),
          updatedAt: new Date(),
        };

        // Update slot availability in eventSchedule
        if (
          this.listing.eventSchedule &&
          this.listing.eventSchedule.length > 0
        ) {
          // Find the slot in eventSchedule that matches the selected slot
          const slotIndex = this.listing.eventSchedule.findIndex(
            (event) => event.slotId === this.selectedSlot.slotId
          );

          if (slotIndex !== -1) {
            // Increment the current guest count by the number of guests
            this.listing.eventSchedule[slotIndex].currentGuestCount =
              (this.listing.eventSchedule[slotIndex].currentGuestCount || 0) +
              this.guestCount;

            // Check if the slot should be marked as unavailable
            const currentEvent = this.listing.eventSchedule[slotIndex];
            if (currentEvent.currentGuestCount >= currentEvent.maxGuestCount) {
              this.listing.eventSchedule[slotIndex].isAvailable = false;
            }

            // Update the listing in Firestore
            const listingRef = doc(db, "listings", this.listingId);
            await updateDoc(
              listingRef,
              { eventSchedule: this.listing.eventSchedule },
              { merge: true }
            );
          }
        }

        // Create the reservation with the new structure
        const reservation = await addDoc(
          collection(db, "reservations"),
          reservationData // Use the new data structure
        );

        reservationData.id = reservation.id;
        reservationData.description = `Credit used for booking ${this.listing.title}`;

        // Consume the credits (multiple credits for multiple guests)
        await creditService.consumeCredit(
          userId,
          this.guestCount,
          reservationData
        );

        // Send confirmation email
        try {
          await this.sendConfirmationEmail(reservation.id, reservationData);
        } catch (error) {
          console.error("Failed to send confirmation email:", error);
          // Don't block the booking process if email fails
        }

        // Close modal and show success message
        this.showConfirmModal = false;

        // Optionally redirect to bookings page
        this.$router.push("/bookings");
      } catch (error) {
        console.error("Error booking private event:", error);
        // Handle error appropriately (show error message)
      }
    },
    formatTimezone(tz) {
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        timeZoneName: "long",
      });
      const parts = formatter.formatToParts(new Date());
      const timeZonePart = parts.find((p) => p.type === "timeZoneName");
      return `${tz} (${timeZonePart.value})`;
    },
    updateDisplayDates() {
      if (
        !this.listing?.eventSchedule ||
        this.listing.eventSchedule.length === 0
      ) {
        // Use current date in the selected timezone
        const today = new Date();
        this.displayStartDate = today;
        this.displayEndDate = today;
        console.log("No event schedule, using today for both dates");
        return;
      }

      // Extract all dates from eventSchedule and convert to Date objects
      const dates = this.listing.eventSchedule.map(
        (event) => new Date(event.datetime)
      );

      // Find the earliest and latest dates
      const earliestDate = new Date(Math.min(...dates));
      const latestDate = new Date(Math.max(...dates));

      // Get today's date
      const today = new Date();

      // Set display dates (ensuring we don't use past dates)
      const startDate = earliestDate < today ? today : earliestDate;
      const endDate = latestDate;

      // Create timezone-adjusted dates by converting to string and back
      // This creates dates that, when displayed, will show in the user's selected timezone
      const startOptions = {
        timeZone: this.userTimezone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      const endOptions = {
        timeZone: this.userTimezone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      // Create a formatted string in the user's timezone
      const startString = startDate.toLocaleString("en-US", startOptions);
      const endString = endDate.toLocaleString("en-US", endOptions);

      // Store the timezone-adjusted dates
      this.displayStartDate = new Date(startString);
      this.displayEndDate = new Date(endString);
    },
    setupCreditBalanceListener() {
      // Clear any existing listener
      if (this.unsubscribe) {
        this.unsubscribe();
      }

      const sessionStore = useSessionStore();
      const userId = sessionStore.userId;

      // If no user is logged in, return early
      if (!userId) {
        this.creditBalance = 0;
        return;
      }

      // Set up listener for credit history to keep balance updated
      const q = query(
        collection(db, "credits"),
        where("userId", "==", userId),
        orderBy("createdAt", "desc")
      );

      this.unsubscribe = onSnapshot(q, (snapshot) => {
        const creditHistory = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.creditBalance =
          creditService.calculateCreditBalance(creditHistory);
      });
    },
    getOccupancyPercentage(slot) {
      const maxGuests = slot.maxGuestCount || 3;
      const currentGuests = slot.currentGuestCount || 0;
      if (maxGuests === 0) return 0;
      return (currentGuests / maxGuests) * 100;
    },
    async sendConfirmationEmail(reservationId, reservationData) {
      const sessionStore = useSessionStore();
      const userEmail = sessionStore.user?.email;

      if (!userEmail) {
        console.warn("User email not found, skipping confirmation email");
        return;
      }

      const reservationIdShort = reservationId.substring(0, 6).toUpperCase();
      const eventDate = new Date(
        reservationData.selectedDate
      ).toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      });

      // Extract guest emails for BCC
      const guestEmails = this.guestInfo
        .filter((guest) => guest.email && guest.email.trim())
        .map((guest) => guest.email.trim());

      const emailData = {
        reservationId: reservationIdShort,
        email: userEmail,
        subject: `Reservation confirmed for ${this.listing.title} on ${eventDate} at ${this.selectedSlot.timeString}`,
        receiverName:
          sessionStore.user?.displayName || sessionStore.user?.email || "Guest",
        hostName: "Skyhost",
        bannerUrl: this.listing.bannerUrl || this.listing.imageUrl,
        eventName: this.listing.title,
        location: this.listing.location,
        eventDate: eventDate,
        eventTime: this.selectedSlot.timeString,
        guestCount: this.guestCount,
        amountPaid: `${this.guestCount} Credit${
          this.guestCount > 1 ? "s" : ""
        }`, // Dynamic based on guest count
        bcc: guestEmails, // Add guest emails as BCC
      };

      return fetch("https://skyhost.ai/send-mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Confirmation email sent successfully");
          return data;
        })
        .catch((error) => {
          console.error("Error sending confirmation email:", error);
          throw error;
        });
    },
  },
  watch: {
    listing: {
      handler() {
        this.updateCalenderAttributes();
        this.updateDisplayDates();
      },
      deep: true,
    },
    userTimezone: {
      handler(newTimezone) {
        console.log("Timezone changed to:", newTimezone);

        // Step 1: Update the display dates for the calendar
        this.updateDisplayDates();

        // Step 2: Reset selected date to clear calendar selection
        this.selectedDate = null;

        // Step 3: Clear the slots array to remove time slot options
        this.slots = [];

        // Step 4: Reset the selected slot
        this.selectedSlot = null;

        // Step 5: Update calendar attributes to reflect the reset state
        this.updateCalenderAttributes();

        console.log("Calendar reset due to timezone change");
      },
    },
    convertedTimezoneSchedule: {
      handler() {
        // Remove setDisabledDatesNew call
      },
      deep: true,
    },
    listingId() {
      this.fetchListing();
    },
  },
  setup() {
    const mainContentClass = computed(() =>
      isMobile() ? "mobile-main-content" : "web-main-content"
    );
    const attrs = ref([
      // {
      //   key: "today",
      //   dot: {
      //     color: "#42b983",
      //   },
      //   dates: new Date(),
      // },
    ]);
    return {
      attrs,
      mainContentClass,
    };
  },
  mounted() {
    const route = useRoute();
    this.listingId = route.query.listingId;
  },
  async created() {
    // Initialize display dates
    this.updateDisplayDates();

    // Set up credit balance listener
    this.setupCreditBalanceListener();
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
/* Container and layout */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
  color: #333;
}

.v-calendar .vc-arrows button {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.container {
  /* display: flex; */
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  overflow: hidden;
  margin-top: 1rem;
}

.left-container {
  max-width: 100%;
  flex: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}

.left-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.right-container {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.disclaimer {
  display: flex;
  align-items: flex-start;
  background-color: #fff3cd; /* Light yellow background */
  color: #856404; /* Dark yellow text */
  padding: 10px 15px; /* Padding for spacing */
  border: 1px solid #ffeeba; /* Border to define the section */
  border-radius: 5px; /* Rounded corners */
  margin-top: 20px; /* Space below the disclaimer */
  width: 350px;
  text-align: left;
  flex-direction: column;
}

.disclaimer span {
  font-size: 0.8rem;
}

.warning-icon {
  margin-bottom: 5px; /* Space between icon and text */
}

.subheading {
  color: #7e7e7e;
  text-align: left;
  font-weight: 400;
  font-size: 0.8;
}

.main-content {
  padding: 2rem;
}

.listing-details {
  display: grid;
  margin: 30px;
  height: auto;
  margin-bottom: 400px;
}

.listing-cover {
  width: 100%;
  height: auto;
  max-height: 350px;
  border-radius: 16px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  object-fit: cover;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.listing-features {
  margin-top: 30px;
  margin-bottom: 30px;
  border-radius: 8px;
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.feature-item i {
  font-size: 16px;
  color: #333;
}

.feature-item-content {
  margin-left: 10px;
}

.feature-item-content p {
  font-size: 12px !important;
}

.feature-item strong {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.feature-item p {
  margin: 0;
  color: #7e7e7e; /* Adjust text color */
  font-size: 0.9rem; /* Adjust text size */
  text-align: left;
}

.map-container {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.map-container strong {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.map-image {
  width: 100%;
  margin-bottom: 1rem;
}

.location-coordinates {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Aligns items to the left and right */
  margin-top: 1rem; /* Add some spacing above */
  gap: 0.3rem;
  align-items: flex-start;
}

.location {
  font-size: 1rem; /* Current style for location */
  color: #333; /* Darker color for location */
}

.coordinates {
  display: flex;
  flex-direction: row; /* Stack latitude and longitude vertically */
  align-items: flex-end; /* Align to the right */
  gap: 0.5rem; /* Add some spacing between latitude and longitude */
}

.latitude,
.longitude {
  font-size: 0.7rem; /* Smaller font size for coordinates */
  color: #7e7e7e; /* Lighter color for coordinates */
  font-weight: 200;
}

.things-container {
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.things-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}

.thing-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem; /* Adjust font size as needed */
  color: #333; /* Darker color for text */
}

.thing-item span {
  margin-left: 8px; /* Space between icon and text */
}

.desktop-app-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.desktop-app-image {
  width: 100%;
  height: auto;
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.listing-description {
  color: #282828;
  text-align: left;
  font-weight: 200;
  font-size: 0.8;
  line-height: 1.3;
  margin-bottom: 1rem;
}

.listing-info {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}

.calendar-section,
.booking-container {
  /* position: fixed; */
  align-items: center;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  height: auto;
  width: 100%;
  flex: 1;
  width: 18rem;
  margin: 0px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  color: #333;
}

.booking-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 20px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.booking-info {
  width: 100%;
  text-align: left;
  margin-left: 20px;
  margin-top: 15px;
}

.select-time-header {
  display: flex;
  align-items: center;
}

.select-time-header p {
  margin-top: 1px;
  margin-left: 5px;
  font-size: 0.8rem;
}

.price-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.price-container span {
  margin-top: 3px;
  font-size: 0.8rem;
}

.slots-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 5px;
  margin-top: 10px;
  width: 85%;
}

.small-chip {
  font-size: 10px;
  padding: 10px 10px;
  border-radius: 20px;
  border: 1px solid #fff;
  cursor: pointer;
}

.selected-chip {
  background-color: #000;
  color: #fff;
}

.disabled-chip {
  background-color: #fff;
  color: #ccc;
  border: 1px solid #f1f1f1;
  cursor: unset;
}

.guest-counter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-right: 30px;
  width: auto;
}

.guest-label {
  display: flex;
  flex-direction: column;
  color: #7e7e7e;
  margin-right: 10px;
}

.guest-label strong {
  color: #000;
  font-size: 0.6rem;
}

.guest-label p {
  font-size: 0.8rem;
  color: #7e7e7e;
}

.counter-controls {
  display: flex;
  align-items: center;
}

.counter-button {
  background-color: #fff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.counter-button:hover {
  background-color: #e5e7eb;
}

.counter-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.guest-count {
  margin: 0 5px;
  font-size: 1.2rem;
  font-weight: bold;
}

.p-inputnumber {
  width: 100%;
}

.booking-summary {
  margin-top: 10px;
  text-align: center;
}

.booking-summary p {
  margin: 5px 0;
}

.booking-options {
  text-align: left;
  width: 100%;
  text-align: left;
}

.booking-options h4 {
  margin-left: 20px;
  margin-bottom: 10px;
}

.options-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  margin: 0 20px;
  justify-content: space-between;
}

.option-item {
  flex: 1; /* Make each option take equal space */
  margin: 0; /* Remove margin to eliminate space between items */
  padding: 5px; /* Add padding for better touch targets */
  border: 1px solid #f2f5f9; /* Optional: Add border for visual separation */
  border-radius: 8px; /* Optional: Rounded corners */
  text-align: left; /* Center text */
  transition: background-color 0.3s; /* Smooth transition for hover */
}

.option-item:hover {
  background-color: #f2f5f9;
}

.option-item.selected-option {
  background-color: #f2f5f9;
}

.option-item span {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #000;
}

.option-item p {
  width: 45px;
  font-size: 0.7rem;
  margin-top: 2px;
  margin-bottom: 5px;
  color: #7e7e7e;
}

.option-item strong {
  font-weight: bold;
  font-size: 0.6rem;
}

.option-item input[type="radio"] {
}

.option-item input[type="radio"]:checked {
  border-color: black; /* Border color when checked */
  background: black; /* Background color when checked */
}

.calculation {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 20px;
}

.calculation p {
  font-size: 0.8rem;
}

.total {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 20px;
}

.total p {
  font-size: 0.8rem;
  font-weight: bold;
}

.booking-summary h4 {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}

.note {
  color: #7e7e7e;
  font-size: 0.7rem;
  font-weight: 300;
}

.line-divider {
  border: none;
  border-top: 1px solid #e6e4e4;
  margin-top: 15px;
  margin-bottom: 5px;
}

.line-divider1 {
  border: none;
  border-top: 1px solid #e6e4e4;
  margin: 10px 20px;
}

.main-btn {
  background-color: #000;
  color: white;
  padding: 0.5rem 1rem;
  margin: 10px 0;
  width: 85%;
  height: 40px;
  border-radius: 8px;
  border: 0px solid #000;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.main-btn:disabled {
  background-color: #ccc;
}

.event-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.event-header-info {
  flex-direction: column;
  justify-content: center;
}

.card-container {
  background: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.stepper-container {
  margin-bottom: 20px;
}

.step-item {
  font-size: 1rem;
  color: #333;
}

.content-panel {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.content-box {
  width: 100%;
  height: 100%;
  border: 2px dashed #dcdcdc;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: #f7f7f7;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-next {
  background-color: #000;
  color: #fff;
}

.btn-back {
  background-color: #e0e0e0;
  color: #000;
}

h2 {
  font-size: 1.5rem;
  color: #222;
  text-align: left;
  margin-bottom: 0.5rem;
}

h3 {
  color: #222;
  align-items: center;
}

.h3-style {
  margin-bottom: 0.5rem;
}

button.logout-button {
  border: none;
  border-radius: 50%;
  color: #333;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

button.logout-button:hover {
  background-color: #e5e7eb !important;
}

.key-points-container {
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

.key-point-widget {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.key-point-icon {
  font-size: 1.2rem;
  color: #000;
}

.key-point-text {
  font-size: 0.9rem;
  color: #333;
}

/* Mobile Booking System Styles */
.booking-container-mobile {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 2rem;
  overflow: hidden;
}

.booking-header-mobile {
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.timezone-selector-mobile {
  width: 100%;
}

.timezone-select-mobile {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #000;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #111827;
  background-color: #fff;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
}

.timezone-info-mobile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.75rem;
}

.select-time-header-mobile {
  margin-top: 1rem;
}

.select-time-header-mobile h4 {
  font-size: 1rem;
  color: #111827;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.mobile-calendar {
  padding: 0 1rem;
  padding-top: 0.5rem;
}

.booking-info-mobile {
  padding: 1.5rem;
  margin-top: -1rem;
}

.empty-slots-container-mobile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px dashed #e5e7eb;
}

.empty-slots-message {
  color: #6b7280;
  font-size: 0.875rem;
  text-align: left;
  line-height: 1.25;
  margin-top: 0.5rem;
}

.slots-container-mobile {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
}

.small-chip-mobile {
  font-size: 0.875rem;
  padding: 0.5rem;
  border-radius: 20px;
  background-color: #f3f4f6;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.selected-chip-mobile {
  background-color: #000;
  color: #fff;
}

.disabled-chip-mobile {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.available-chip-mobile {
  background-color: #d1fae5;
  color: #065f46;
}

.warning-chip-mobile {
  background-color: #ffedd5;
  color: #9a3412;
}

.danger-chip-mobile {
  background-color: #fee2e2;
  color: #b91c1c;
}

.chip-content-mobile {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
}

.chip-time-mobile {
  font-size: 0.75rem;
  font-weight: 500;
}

.chip-availability-mobile {
  font-size: 0.7rem;
  opacity: 0.7;
  font-weight: 400;
}

.booking-summary-mobile {
  padding: 1.5rem;
  border-top: 1px solid #f3f4f6;
}

.summary-row-mobile {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.summary-label-mobile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}

.summary-label-mobile p {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
  margin: 0;
}

.summary-label-mobile span {
  font-size: 0.8rem;
  color: #6b7280;
}

.summary-value-mobile {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
  margin: 0;
}

.credit-balance-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-top: 1px solid #f3f4f6;
  margin-bottom: 1.5rem;
}

.credit-balance-mobile p {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
  margin: 0;
}

.book-button-mobile {
  width: 100%;
  padding: 0.875rem;
  background-color: #000;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.book-button-mobile:hover:not(:disabled) {
  background-color: #111827;
}

.book-button-mobile:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}

.terms-note-mobile {
  text-align: center;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 1rem;
  margin-bottom: 0;
}

/* Guest Counter Mobile Styles */
.guest-counter-section-mobile {
  padding: 1.5rem;
}

.guest-counter-container-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #fff;
}

.guest-counter-label-mobile h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.25rem 0;
  letter-spacing: 0.05em;
}

.guest-counter-label-mobile p {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.guest-counter-controls-mobile {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.guest-counter-btn-mobile {
  width: 32px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background-color: #fff;
  color: #374151;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.guest-counter-btn-mobile:hover:not(:disabled) {
  border-color: #9ca3af;
  background-color: #f9fafb;
}

.guest-counter-btn-mobile:disabled {
  background-color: #f3f4f6;
  color: #d1d5db;
  cursor: not-allowed;
  border-color: #e5e7eb;
}
/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .mobile-calendar .vc-container {
    border: none !important;
  }

  .timezone-select-mobile {
    font-size: 0.8rem;
  }

  .small-chip-mobile {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  .booking-container-mobile {
    margin: 1rem 0;
  }

  .guest-counter-btn-mobile {
    width: 28px;
    height: 28px;
    font-size: 1.1rem;
  }

  .guest-counter-controls-mobile {
    gap: 0.75rem;
  }
}
</style>
